import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import User from 'components/ControlledUser'
import {
  Content,
  ContentHeader,
  ContentTitle,
  ContentIcon
} from 'components/Content'
import {
  ToggleModal
} from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import RelativeDate from 'components/RelativeDate'
import usersClasses from '../Users.module.scss'
import classes from './Visitors.module.scss'

export class Visitors extends React.Component {
  static propTypes = {
    visitors: PropTypes.array.isRequired,
    isAnyVisitorInCard: PropTypes.bool.isRequired
  }

  state = {
    show: false
  }

  hideModalToggle = () => {
    this.setState({
      show: false
    })
  }

  handleModalToggle = (show) => {
    this.setState({
      show
    })
  }

  render () {
    const {
      visitors,
      isAnyVisitorInCard
    } = this.props
    const {
      show
    } = this.state

    if (visitors.length === 0) return null

    let className = null
    if (isAnyVisitorInCard) {
      className = classes.visitorOnline
    }

    return (
      <ToggleModal
        backdrop
        show={show}
        onToggle={this.handleModalToggle}
        attachment='top left'
        targetAttachment='top left'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        <ContentIcon
          className={className}
        >
          <KanBoIcon name='kanbo-16-viewed-by' />
          <span style={{ fontSize: 14, marginLeft: '0.25em' }}>{visitors.length}</span>
        </ContentIcon>
        <div className={usersClasses.modalWrapper}>
          <Content
            className={usersClasses.modal}
            style={{ padding: 0 }}
          >
            <ContentHeader className={usersClasses.modalHeader}>
              <ContentIcon>
                <KanBoIcon name='kanbo-16-viewed-by' />
              </ContentIcon>
              <ContentTitle>
                <FormattedMessage
                  id='CARD_VISITORS'
                  values={{
                    count: visitors.length.toString()
                  }}
                />
              </ContentTitle>
            </ContentHeader>
            <div style={{ overflow: 'auto' }}>
              {visitors.map(visitor =>
                <User
                  listItem
                  key={visitor.id}
                  id={visitor.id}
                  defaultMenu
                  presence
                  subtitle={
                    (visitor.action && visitor.action === 'Being') ? (
                      <FormattedMessage id='USER_PRESENCE_IS_IN_CARD' />
                    ) : (
                      <RelativeDate pastOnly timestamp={visitor.timestamp}/>
                    )
                  }
                  onShowProfile={this.hideModalToggle}
                  onShowActivities={this.hideModalToggle}
                />
              )}
            </div>
          </Content>
        </div>
      </ToggleModal>
    )
  }
}

export default Visitors
